export class NotificationSubject{
    companyname:string;
    firstname:string;
    idpartner:string;
    idprovider:string;
    iduser:string;
    lastname:string;
    logo:string;
    providerrcs:string;
}